//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapMutations} from 'vuex'
import {editUserInfo, fetchUser} from '@/api/user'

export default {
  data () {
    return {
      userInfo: {
        name: '',
        email: '',
        qq: '',
        company: ''
      },
      type: ''
    }
  },
  methods: {
    ...mapMutations({
      setTitleVuex: 'SET_TITLE'
    }),
    // 修改小程序头部名称
    changeNavTitle (title) {
      const newTitle = `修改${title}`
      this.setTitleVuex(newTitle)
      // wx.setNavigationBarTitle({
      //   title: '修改' + title
      // });
    },
    getUserInfo () {
      fetchUser().then(resp => {
        this.userInfo = {
          name: resp.data.name,
          email: resp.data.email,
          qq: resp.data.qq,
          company: resp.data.company
        }
      })
    },
    handleSave () {
      editUserInfo(this.userInfo).then(resp => {
        this.$router.go(-1)
      }).catch((err) => {
        if (err.status === 422) {
          this.$vux.toast.show({
            text: err.message,
            time: 3000
          })
        }
      })
    }
  },
  mounted () {
    if (this.$route.query.type) {
      this.type = this.$route.query.type
      this.changeNavTitle(this.type)
    }
    this.getUserInfo()
  }
}



// WEBPACK FOOTER //
// ./src/pages/profileEdit/index.vue